import { assertCanHandle } from '@lucidlink/tscore';
import { canHandleAllErrors, PeriodicTaskBase } from '#common/util';
const DEFAULT_FLUSH_INTERVAL_MS = 5000;
export class StatsFlusher extends PeriodicTaskBase {
    metaStore;
    accumulators = new Array();
    constructor(metaStore, intervalMs) {
        super('StatsFlusher', intervalMs || DEFAULT_FLUSH_INTERVAL_MS);
        this.metaStore = metaStore;
    }
    register(accumulator) {
        this.accumulators.push(accumulator);
    }
    async load() {
        await Promise.all(this.accumulators.map((accumulator) => accumulator.load()));
    }
    async stop() {
        await super.stop();
        this.log.trace('Flushing stats on stop.');
        await this.flush();
    }
    async flush() {
        const batches = this.accumulators.map((accumulator) => ({ accumulator, ...accumulator.getBatch() }));
        const records = batches.flatMap((batch) => batch.records);
        if (records.length === 0) {
            return;
        }
        try {
            this.log.trace('Sending stats.');
            await this.metaStore.commitKeyValuePairs(records, true);
        }
        catch (err) {
            assertCanHandle(err, canHandleAllErrors);
            this.log.warn({ errorMessage: err }, 'Failed to send stats.');
            return;
        }
        for (const batch of batches) {
            batch.accumulator.applyCommitted(batch.values);
        }
    }
    async execute() {
        this.log.trace('Flushing stats on timer.');
        await this.flush();
    }
}
